import DamagedPointPicture from '@/common/components/camera/assets/VehicleDamagedPoint.png';
import MotorDamagedPointPicture from '@/common/components/camera/assets/motorDamagedPoint.png';
import { ImageSliderPropsType } from '@/common/components/camera/types/components.type';
import { VehicleTypesType } from '@/common/types/Files.type';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const DamagedPointSlider = ({
  sliderData,
  turn,
  vehicleType,
}: {
  sliderData: ImageSliderPropsType['sliderData']['damaged_parts'];
  turn: ImageSliderPropsType['turn'];
  vehicleType: VehicleTypesType;
}) => {
  const isMotor = vehicleType === 'motorcycle';
  return (
    <Box
      className={css({
        position: 'fixed',
        top: '35px',
        right: '10px',
        width: '100vw',
        maxWidth: 'maxContainer',
        transition: 'all 0.7s ease-out',
        height: '9rem',
      })}
    >
      <Box className={css({ display: 'flex' })}>
        <Box className={css({ display: 'flex', flexDirection: 'column' })}>
          <Box
            key={sliderData[turn]?.id}
            backgroundColor="white"
            className={css({
              p: '5px',
              width: '75px',
              height: '105px',
              border: '2px solid ',
              borderColor: 'purple-primary',
              borderRadius: '8px',
            })}
          >
            <img
              className={css({
                width: '100%',
                height: '100%',
              })}
              src={isMotor ? MotorDamagedPointPicture : DamagedPointPicture}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DamagedPointSlider;
